export enum RepetitionGranularity {
  Minute = "Minuta",
  Hour = "Hodina",
  Day = "Den",
  Week = "Týden",
  Month = "Měsíc",
}
